import React, { useEffect, useState } from 'react';
import { Heart, X, Check } from 'lucide-react';

const Toast = ({ message, type = 'success', isVisible, onClose }) => {
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setIsAnimating(true);
      const timer = setTimeout(() => {
        setIsAnimating(false);
        setTimeout(onClose, 300);
      }, 2500);
      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose]);

  if (!isVisible && !isAnimating) return null;

  const icons = {
    success: Check,
    wishlist: Heart,
    error: X
  };

  const Icon = icons[type] || Check;

  return (
    <div
      className={`fixed bottom-24 left-1/2 -translate-x-1/2 z-[100] transition-all duration-500
        ${isAnimating ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
    >
      <div className="glass bg-[#0A0A0A]/90 backdrop-blur-xl text-white px-6 py-3.5 rounded-2xl shadow-2xl flex items-center gap-3">
        <span className={`p-1.5 rounded-full ${type === 'wishlist' ? 'bg-black' : 'bg-[#0A0A0A]/20'}`}>
          <Icon size={12} className={type === 'wishlist' ? 'fill-white' : ''} />
        </span>
        <span className="text-sm font-light tracking-wide">{message}</span>
      </div>
    </div>
  );
};

export default Toast;
